import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import Image from '@/assets/images/landing-banner-img.webp';
import { BigTitle, Title } from '@/components';

function LandingBanner() {
  const { t } = useTranslation();

  return (
    <div tw='flex sm:flex-row flex-col-reverse items-center gap-5'>
      <div tw='flex flex-col justify-between gap-5'>
        <BigTitle
          text={<span>{t('info_landing.banner.title')}</span>}
          twStyle={tw`sm:text-[45px] text-[30px] text-[#70FF6E]`}
        />
        <Title text={<span>{t('info_landing.banner.subtitle')}</span>} />
      </div>
      <img src={Image} alt='картинка' tw='xl:max-w-[280px] md:max-w-[300px] sm:max-w-[280px]' />
    </div>
  );
}

export default LandingBanner;
